import { initializeApp } from 'firebase/app';
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {

  apiKey: "AIzaSyCvE_7P0MMp4KuAs-6waBmzpMgaTWMPKG8",
  authDomain: "online-resource-center.firebaseapp.com",
  projectId: "online-resource-center",
  storageBucket: "online-resource-center.appspot.com",
  messagingSenderId: "63966447478",
  appId: "1:63966447478:web:2bd2077168d9268fbd9c57",
  measurementId: "G-PJQ952V1XK"

};

  
  const app = initializeApp(firebaseConfig);

  export const db = initializeFirestore(app, {
    experimentalForceLongPolling: true,
  });


  
  export const auth = getAuth(app);
  export const database = getDatabase(app);
  export const storage = getStorage(app);

